import React, { useEffect, useState } from 'react';
import { Grid, Typography, Tooltip } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';

import { useSelector } from 'react-redux';
import LimitError from '@Common/components/LimitError';
import { RootState } from '@Common/models/redux/store';

const useStyles = makeStyles((theme) => ({
  charSummaryInnerContainer: {
    maxWidth: (props: any) => (props.isExtension ? '100%' : '350px'),
    flexWrap: 'nowrap',
    justifyContent: 'center',
    height: '54px',
    [theme.breakpoints.down(600)]: {
      paddingLeft: '6px',
    },
  },
  tooltip: {
    fontSize: '13px',
  },
  wordLimit: {
    alignItems: 'center',
    fontWeight: 600,
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
}));

const WordSummary = ({
  wordCount,
  showCharLimitMessage,
  wordLimit,
  topLevelComponent,
  characterCount,
  forceExtensionCheck,
}: any) => {
  const isMobile = useSelector((state: RootState) => state.common.platform?.isMobile);
  const isExtension = useSelector((state: RootState) => state.common.platform?.isExtension);

  const [showLimitBox, setShowLimitBox] = useState(true);
  const classes = useStyles({ isExtension });

  const closeItem = () => {
    setShowLimitBox(false);
  };

  useEffect(() => {
    if (showCharLimitMessage && !showLimitBox) setShowLimitBox(true);
  }, [showCharLimitMessage]);

  return (
    <Grid container>
      {showCharLimitMessage &&
      showLimitBox &&
      !isMobile &&
      (!isExtension || forceExtensionCheck) &&
      wordLimit > 0 ? (
        <Grid
          item
          container
          xs={12}
          direction="column"
          className={classes.charSummaryInnerContainer}
        >
          <LimitError
            onClose={closeItem}
            topLevelText={topLevelComponent}
            wordCount={wordCount}
            limit={wordLimit}
          />
        </Grid>
      ) : (
        <Tooltip
          title={`${characterCount} Characters`}
          arrow
          placement="top"
          classes={{
            tooltip: classes.tooltip,
          }}
        >
          <Grid item style={{ paddingLeft: '20px' }}>
            <Typography display="inline" variant="body2" className={classes.wordLimit}>
              {!showCharLimitMessage || wordLimit <= 0 ? wordCount : <b>{wordCount}</b>}
              {!showCharLimitMessage || wordLimit <= 0 ? ' ' : `/${wordLimit} `}
              Word
              {wordCount === 1 ? '' : 's'}
            </Typography>
          </Grid>
        </Tooltip>
      )}
    </Grid>
  );
};

export default WordSummary;
